<template>
  <div class="task-header">
    <div>
      <div :class="isExclude && 'excluded'">
        {{ $t('report_tasks.task_prefix') }}

        {{ taskName }}
      </div>
      <b-checkbox
        @input="onItemToExclude"
        v-model="isExclude"
        v-if="enableExcludeItems"
      />

      <b-switch
        style="margin-left: 20px"
        v-if="!isInternalReport && taskType === 'diagram'"
        :type="'is-danger'"
        v-model="enabledOutOfToleranceColors"
        >{{ $t('report_tasks.show_oot_colors') }}</b-switch
      >
    </div>

    <b-button
      outlined
      type="is-info"
      icon-right="file-download-outline"
      @click="onExportTask"
      :loading="exportingTask"
      >{{ $t('export_task') }}</b-button
    >
  </div>
</template>

<script>
import ExcludeItemsMixin from '../../../mixins/Report/ExcludeItemsMixin';

import {
  REPORTS_UPDATE_CUSTOMER_OUT_OF_TOLERANCE,
  REPORTS_EXPORT_TASK,
} from '../../../store/reports/actions/actionTypes';

export default {
  name: 'TaskName',
  props: {
    taskName: {
      type: String,
      default: '',
      required: true,
    },
    id: {
      type: String,
      default: '',
      required: true,
    },

    customerOutOfToleranceColors: {
      type: Boolean,
      default: false,
    },

    taskType: {
      type: String,
      default: '',
      required: false,
    },
  },
  mixins: [ExcludeItemsMixin],
  computed: {
    isInternalReport() {
      return this.$store.getters['ReportsModule/isInternalReport'];
    },
  },
  data() {
    return {
      exportingTask: false,
      enabledOutOfToleranceColors: this.customerOutOfToleranceColors,
    };
  },

  watch: {
    enabledOutOfToleranceColors(newValue) {
      this.$emit('input', newValue);
      this.$store.dispatch(REPORTS_UPDATE_CUSTOMER_OUT_OF_TOLERANCE, {
        id: this.id,
        value: newValue,
      });
    },
  },

  methods: {
    async onExportTask() {
      try {
        this.exportingTask = true;
        let canvas;
        if (this.taskType === 'diagram') {
          const taskCanvasDiagram = document.getElementById(
            `canvas-diagram-${this.id}`
          );

          if (!taskCanvasDiagram) return;
          canvas = taskCanvasDiagram.toDataURL();
        }

        const { downloadPath } = await this.$store.dispatch(
          REPORTS_EXPORT_TASK,
          {
            taskId: this.id,
            isInternalReport: this.isInternalReport,
            api_endpoint: process.env.VUE_APP_API_ENDPOINT,
            canvas,
          }
        );

        this.triggerDownload(downloadPath);
      } catch (error) {
        this.$buefy.toast.open({
          duration: 5000,
          message: `Error exporting task: ${this.taskName} - Please try again later.`,
          position: 'is-top',
          type: 'is-danger',
        });
        console.error('Error exporting task:', error);
      } finally {
        this.exportingTask = false;
      }
    },

    triggerDownload(downloadLink) {
      const anchor = document.createElement('a');
      anchor.style.display = 'none';
      anchor.href = downloadLink;
      anchor.setAttribute('download', '');

      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
    },
  },
};
</script>

<style lang="scss" scoped>
.task-header {
  font-family: 'Siemens Sans';
  font-size: 18px;
  display: flex;
  flex: 1;
  margin-top: 35px;
  align-items: center;
  justify-content: space-between;
  .checkbox {
    margin-left: 10px;
  }

  div {
    display: flex;
    align-items: center;
  }
}

.excluded {
  text-decoration: line-through;
}
</style>
